import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import RuleView from '@gnb/components/Preference/Mail/Rule/RuleView.vue'
import AddRule from '@gnb/components/Preference/Mail/Rule/AddRule.vue'
import { mapActions, mapGetters } from 'vuex'
import * as dateutil from '@appbase/util/date-helper'
import api from '@gnb/api/common'
import MultiAccountModal from './Modals/MultiAccountModal.vue'
import MultiAccountView from '@gnb/components/Preference/Mail/MultiAccount/MultiAccountView.vue'
@Component({
    components:{
        ModalHeader,
        ModalContent,
        ModalFooter,
        ContentItem,
        PreferenceContentTemplate,
        RuleView,
        AddRule,
        MultiAccountView,
        MultiAccountModal
    }, 
    methods:{
        ...mapActions({
        })
    },
    computed:{
        ...mapGetters({
        })
    }
})
export default class MultiAccount extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    show: boolean = false;
    header: string = '멀티계정 목록';
    multiList: Array<gnb.multiMail> = [];
    selectedItem: gnb.multiMail = {
        personCode: '',
        email: '',
        isUse: false,
        isDeleted: false,
        displayOrder: 1,
        createdId: '',
        createdDate: new Date(),
        updatedId: '',
        updatedDate: new Date(),
    }

    tempRecipients: orgmap.UserItem = {
        comCode:'',
        deptCode:'',
        deptName:'',
        displayName:'',
        email:'',
        id:'',
        parentDeptCode:'',
        personCode:'',
        selected: false,
        titleName:''
    } as orgmap.UserItem;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getMultiMailList(){
        api.getMultiMailList().then((res:gnb.multiMail[])=>{
            this.multiList = res;
        })
    }

    move(from: number, to: number){
        this.multiList.forEach((m,index)=>{
            if(index === from){
               m.displayOrder = to + 1;
            }else if(index === to){
                m.displayOrder = from + 1;
            }
        });
    }
  
    edit(item:gnb.multiMail){
        this.show = true;
        this.selectedItem = item;
    }

    save(){
        if(this.selectedItem?.id){
            let id = parseInt(this.selectedItem.id as string);
            this.selectedItem.id = id;
            api.setMultiMail([this.selectedItem]).then(async ()=>{
                await(window as any).alertAsync('수정되었습니다.')
            })
        }else{
            this.selectedItem.displayOrder = this.multiList.length + 1;
            api.setMultiMail([this.selectedItem]).then(async ()=>{
                await(window as any).alertAsync('저장되었습니다.')
            })
        }
        this.selectedItem = {} as gnb.multiMail;
                this.tempRecipients = {} as orgmap.UserItem ;
                this.close();
    }

    deleteItem(item:any){
      this.multiList.forEach((m)=>{
          if(m.id == item.id){
              m.isDeleted = true;
          }
      })
    }

    saveList(){
        // this.multiList.filter((mail)=>{return !mail.isDeleted}).map((mail)=>{
        //     if(!mail.isDeleted){
        //         mail.displayOrder = this.multiList.filter((mail)=>{return !mail.isDeleted}).indexOf(mail)
        //     }else{
        //         mail.displayOrder = 0;
        //     }
        // })
        //this.multiList.forEach((mail)=>{if(mail.isDeleted){mail.displayOrder = 0}})
        api.setMultiMail(this.multiList).then(async (res)=>{
            await(window as any).alertAsync('저장되었습니다.');
        });
    }

    open(){
        this.selectedItem = {
            personCode: '',
            email: '',
            isUse: false,
            isDeleted: false,
            displayOrder: 1,
            createdId: '',
            createdDate: new Date(),
            updatedId: '',
            updatedDate: new Date(),
        }
        this.show = true;
    }
    
    close(){
        this.show = false;
        this.getMultiMailList();
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    
    created(){
        this.getMultiMailList();
    }
}